import { ThemeProvider } from "@emotion/react";
import "./App.css";
import RouterWrapper from "./router/Router";
import { defaultTheme } from "./styles/muiTheme";
import UpdateFormProvider from "./context/UpdateFormProvider";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';


function App() {
  return (
    <>
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <ThemeProvider theme={defaultTheme}>
      <UpdateFormProvider>
        <RouterWrapper />
       </UpdateFormProvider>
      </ThemeProvider>
      </LocalizationProvider>
    </>
  );
}

export default App;
